import clean from 'lodash-clean';
import { connect } from 'react-redux';

import CommunityMessagesComponent from './CommunityMessagesComponent';

import { getChats } from '../actions';

const mapStateToProps = (state, ownProps) => {
  const { match } = ownProps;
  const hasSelectedChat = Boolean(match?.params?.id);
  return {
    hasSelectedChat,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getThreadsList: (queryParams, withReset) =>
    getChats(dispatch, clean(queryParams), withReset),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunityMessagesComponent);
